import * as actions from './actions';

const initialState = {
  checkedIds: [],
};

export default function checkboxReducer(state = initialState, action) {
  switch (action.type) {
    case actions.CHECKED_ID: {
      return {
        checkedIds: [
          ...state.checkedIds,
          action.payload,
        ],
      };
    }
    case actions.UNCHECKED_ID: {
      return {
        checkedIds: state.checkedIds.filter(ids => ids !== action.payload),
      };
    }
    default:
      return state;
  }
}
